<template>
    <div>

        <vx-card title="Select View" class="eachAttendence_card mb-4">
          <!-- <vs-button
          @click="$router.push({name:'attendanceTeacher'}).catch(()=>{})"
          >Back</vs-button> -->
            <div class="md:flex">
               <div class="p-1 lg:w-1/4 w-full">
          <v-select
            append-to-body
            class="w-full"
            label="name"
            :reduce="(option) => option.id"
            :options="courseList"
            v-model="selectedCourseId"
            :clearable="true"
            placeholder="Enter Course Name"
          ></v-select>
        </div>
       <!-- <pre> {{courseList}}</pre> -->

        
       <!-- <pre> {{courseList}}</pre> -->

        <!-- <div class="p-1 lg:w-1/3 w-full"> -->
         <!--  <v-select
            append-to-body
            class="w-full"
            label="first_name"
            :reduce="(option) => option.id"
            :options="teacherList"
            v-model="teacherId"
            :clearable="false"
            placeholder="Enter Teacher Name"
          ></v-select> -->
          <!-- {{teacherId}} -->
       <!--    {{teacherList}}
          {{teacherId}} -->
        <!-- </div> -->
               <div class="p-1 lg:w-1/4 w-full">
          <v-select
            append-to-body
            class="w-full"
            label="first_name"
            :options="attendanceTypeOptions"
            v-model="attendanceType"
            :clearable="false"
            placeholder="Attendance Type"
          ></v-select>
          
        </div>

                <div class="p-1 lg:w-1/4 w-full">
                    <date-range-picker
                        ref="picker"
                        class="cstm_date w-full mr-2"
                        :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY HH:mm:ss' }"
                        :showWeekNumbers="true"
                        :showDropdowns="true"
                        :autoApply="true"
                        :ranges="customDateRanges()"
                        v-model="dateRange"
                    >
                        <template v-slot:input="picker" style="min-width: 350px">
                            <span v-if="dateRange.startDate === null || dateRange.endDate === null" style="color: rgba(0, 0, 0, 0.5); font-weight: 400; font-size: 12px;">Select Date Range</span>
                            <span v-else>{{ picker.startDate | date }} - {{ picker.endDate | date }}</span>
                        </template>
                    </date-range-picker>
                </div>

               <div class="p-1 flex">
            <vs-button class="includeIcon includeIconOnly" @click.prevent="filterGoMethod()">Go</vs-button>

          <!-- <vs-tooltip text="Reset">
                        <vs-button type="border" icon-pack="feather" icon="icon-refresh-ccw" class="ml-2"></vs-button>
                    </vs-tooltip> -->
        </div>
            </div>
        </vx-card>


<!-- {{$route}} -->
            <teacherattendace-list 
            :filterPayload="filterPayload"
            :client_user_id="client_user_id"
            ></teacherattendace-list>

            <!-- {{$route}} -->
            <!-- {{$route.params}} -->


       <!--  <attendance-list
      :filterPayload="filterPayload"
      :client_user_id="client_user_id"
    ></attendance-list> -->
   
    </div>
</template>
<script>
import vSelect from 'vue-select'
import DateRangePicker from 'vue2-daterange-picker'
//you need to import the CSS manually
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import TeacherattendaceList from './components/TeacherattendaceList.vue'
import { attendanceMixin } from './mixins/attendanceMixin'

export default {
  name: 'eachAttendance',
  mixins:[attendanceMixin],
  components: {
    vSelect,
    DateRangePicker,
    TeacherattendaceList
  },
  data () {
    return {
      dateRange: { startDate: new Date(), endDate: new Date() },
      filterPayload:{
        course_id:null,
        start_date:this.$moment(new Date()).format('YYYY-MM-DD'),
        end_date:this.$moment(new Date()).format('YYYY-MM-DD'),
        teacher_id:null,
        client_user_id:null,
        attendance_type:'All'

        
      },
      client_user_id:null
    }
  },
  created () {
    if (!this.$route.params.clientObject) {
      this.$router.push({name:'attendanceTeacher'})
    }
    this.user_id = this.$route.params.user_id
    this.filterPayload.user_id = this.user_id
  },
  methods:{
    filterGoMethod () {
     
      this.filterPayload.course_id = this.selectedCourseId
      this.filterPayload.teacher_id = this.teacherId
      this.filterPayload.user_id = this.user_id
      this.filterPayload.start_date = this.$moment(this.dateRange.startDate).format("YYYY-MM-DD")
      this.filterPayload.end_date = this.$moment(this.dateRange.endDate).format("YYYY-MM-DD")
      this.filterPayload.attendance_type = this.attendanceType

      console.log(this.filterPayload)
      console.log('HI')
    }
  }
}
</script>
<style>
.eachAttendence_card .vue-daterange-picker .form-control {
    padding: 7px 10px;
    border-radius: 4px;
}
.attendance-badge {
    display: inline-block;
    margin: 5px 5px 5px 0;
    text-align: center;
    border-radius: 10rem;
    text-transform: capitalize;
    padding: 2px 10px;
    font-weight: 600;
}
.attendance-badge.present {
    background-color: rgba(40, 199, 111, 0.12);
    color: #28c76f !important;
}
.attendance-badge.absent {
    background-color: rgba(220, 53, 69, 0.12);
    color: #dc3545 !important;
}
</style>